import { IPoint, subPoints } from "../../helpers/Geometry";
import { IListener, clearEvents, onDown, onDrag } from "../../helpers/TouchHelper";
import { BaseViewTool } from "./BaseViewTool";

const PAN_TOOL = "PAN";

export class PanTool extends BaseViewTool {

    protected _startCenter: IPoint;
    protected _startWorld: IPoint;
    protected _dragData: IListener[];

    constructor() {
        super()
    }

    override activate() {
        super.activate();

        this._dragData = onDrag(this._host.container,
            (pos, button) => {

                if (button != 0 || this._isStarted)
                    return false;

                this._isStarted = true;

                this._startCenter = {
                    ...this._host.origin
                };

                this._startWorld = this._host.viewToWorld(this.getViewPoint(pos));

                return true;
            },
            (pos) => {

                this._host.container.style.cursor = "grab";

                this._host.beginUpdate();

                this._host.origin = this._startCenter;

                const curWorld = this._host.viewToWorld(this.getViewPoint(pos));

                const deltaWorld = subPoints(curWorld, this._startWorld);

                this._host.origin = {
                    x: this._startCenter.x - deltaWorld.x,
                    y: this._startCenter.y - deltaWorld.y,
                }

                this._host.endUpdate();

                return true;


            },
            () => {

                this._isStarted = false;

                this._host.container.style.removeProperty("cursor");

                this._host.requestRenderAsync();

            }
        );
    }

    override deactivate() {

        clearEvents(...this._dragData);

        super.deactivate();
    }
    

    readonly name = PAN_TOOL;
}